import {
  Area,
  AreaChart,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
} from "recharts";
import { useTranslate } from "src/i18n";

export const Chart = () => {
  const { t } = useTranslate();
  return (
    <ResponsiveContainer width={"100%"} height={250}>
      <AreaChart
        width={800}
        accessibilityLayer
        data={chartData}
        margin={{
          left: 12,
          right: 12,
        }}
      >
        <CartesianGrid
          stroke="var(--g-color-base-generic-medium)"
          vertical={false}
        />
        <Area
          dataKey="without"
          name={t("landing.main_block.chart.legend_1", "Без нашего сервиса")}
          type="natural"
          fill="var(--g-color-base-info-heavy)"
          fillOpacity={0.4}
          stroke="var(--g-color-base-info-heavy)"
          stackId="a"
        />
        <Area
          dataKey="with"
          name={t("landing.main_block.chart.legend_2", "С нашим сервисом")}
          type="natural"
          fill="var(--g-color-base-brand)"
          fillOpacity={0.4}
          stroke="var(--g-color-base-brand)"
          stackId="a"
        />
        <Legend />
      </AreaChart>
    </ResponsiveContainer>
  );
};

const chartData = [
  { with: 186, without: 80 },
  { with: 305, without: 200 },
  { with: 237, without: 120 },
  { with: 73, without: 190 },
  { with: 209, without: 130 },
  { with: 214, without: 140 },
];
